<template>
    <div id="container" style="padding: 0px;">
        <a-spin :spinning="reloading" tip="正在加载中" wrapperClassName="spinClass" style="    height: 100%;">
            <div style="display: flex;width: 100%;height: 100%;">
                <div  style ="width: 9rem;border-right: 1px solid #f0f0f0;padding: 28px 0px;text-align: left;">
                     <div style="font-size: 16px;" class="appName">
                       <div style="padding-left: 18px;">
                        <CaretRightOutlined  style="margin-right: 2px;"/>{{ cardItem.appName }}</div>
                       </div>
                    <div style="margin-top: 10px;">
                        <div @click="toClickContainerId(item)" v-for="(item,index ) in cardItem.containers " :class="{'cardItem':true,selected:Number(item.id)==containerItem.id}">
                         <div style="padding-left: 38px;">{{ item.name }}</div>
                        </div>
                    </div>
                </div>
                <div style="flex: 1;padding: 20px ;" :style="scrollView">
                    <div  class="head" >
                    <div>{{ containerItem.name }}</div>
                    
            <div class="search" >
                <div>
                    <h2 class="title">当前知识库文件数（{{ pagination.total}}）</h2>
                    <div class="volumnText">(剩余上传流量 <text v-if="dotLoading" class="dots-loader"></text> <text v-else>
{{ remainStorageValue }}</text> )</div>
                </div> 
                
                <!--<h2 class="title">当前知识库文件数（{{ pagination.total}}）</h2>-->
                <a-input placeholder="请输入"  style="width: 200px;" v-model:value="eleName" allowClear></a-input>
                <a-button type="primary" style="width: 50px; background: #00b2b9;  border-color: #00b2b9;    margin: 0 10px;" @click="onSearch">
                  <template #icon>
                     <SearchOutlined  style="color:white" @click="toSearch()"/>
                  </template>
               </a-button>
               <a-button  @click="toImport">知识导入</a-button>
               <!-- <a-upload     :multiple="true" :accept="acceptedFormats"
               :max-count="10"  :before-upload="beforeUpload">
                <a-tooltip>
                    <template #title>
                            <span style="word-break: keep-all;">支持格式：.pdf/.ppt/.docx/.doc/.txt/.md/.html/.xls/.xlsx</span>
                        </template>
                    <a-button  >知识导入(一次最多上传10个文件)</a-button>
                </a-tooltip>
               </a-upload> -->
            </div>
            </div>
            <div class="scrollView">
                 <a-table @change="handleTableChange"   tableLayout="fixed"  :pagination="pagination"   :columns="columns" :data-source="documentList" bordered class="tablestyle commentPageStyle">
                    <template #bodyCell="{ text, record, index, column }">
                        <template v-if="column.dataIndex === 'eleName'">
                            <div style="display: flex;align-items: center;">
                                <svg-icon :name="getSvgName(record.eleSuffix)" size="40" style="    margin-right: 5px;"/>
                                <a class="single-line-ellipsis table_name" :href="record.elePreviewUrl" target="_blank">{{ text }}</a>
                            </div>
                          
                        </template>
                        <template v-if="column.dataIndex === 'createTime'">
                            <span>{{ getTime(text) }}</span>
                          
                        </template>
                        <template v-if="column.dataIndex === 'processStatus'">
                          
                            <span v-if="record.processStatus==20" style="color: rgb(82, 196, 26);">解析完成 <CheckCircleOutlined /></span>
                            <span v-else-if="record.processStatus==30"  style="color: #f34d4d;">解析失败 <CloseCircleOutlined /></span>
                              <span v-else style="color: #ff9800;">解析中 <ExclamationCircleOutlined /></span>
                        </template>
                        <template v-if="column.dataIndex === 'action'">
                            <a-popconfirm v-if="record.processStatus==20||record.processStatus==30"
                            title="删除后不可恢复，确认删除?"
                            ok-text="确认"
                            cancel-text="取消"
                            @confirm="toDeleteConfirm(record.id)"
                            @cancel="cancel"
                            >
                                <a style="color: red;">删除</a>
                            </a-popconfirm>
                      
                                <a  v-else style="color: gray;    cursor: not-allowed;">删除</a>
                           
                        </template>
                    </template>
                 </a-table>
            </div>
                </div>
            </div>

   
        </a-spin>
        <a-modal v-model:visible="visible" title="知识导入" :maskClosable="false" @cancel="handleCancel"  @ok="handleOk" width="40%"  :confirm-loading="confirmLoading"
        class='dialogKnowledgeClass'
       >
            <!-- <a-alert message="一次最多上传10个文件，支持格式：.pdf/.ppt/.docx/.doc/.txt/.md/.html/.xls/.xlsx" type="success" /> -->
            <a-upload-dragger style="margin: 10px 0px 10px 0px;"
    v-model:fileList="fileList"
    name="file"
    :multiple="true"
    :beforeUpload="beforeUpload"
    :accept="acceptedFormats"
    @change="handleChange"
    @drop="handleDrop"
  >
    <p class="ant-upload-drag-icon">
        <plus-circle-outlined  color="#00b2b9"/>
    </p>
    <p class="ant-upload-text">拖拽文件至此，或者 <a>选择文件</a></p>
    <p class="ant-upload-hint">
        一次最多上传10个文件，支持格式：.pdf/.ppt/.pptx/.docx/.doc/.txt/.md/.html/.xls/.xlsx
    </p>
  </a-upload-dragger>
        </a-modal>
    </div>
</template>
<script setup>
import {SearchOutlined,PlusCircleOutlined,CaretRightOutlined,CheckCircleOutlined,CloseCircleOutlined,ExclamationCircleOutlined} from '@ant-design/icons-vue'
import router from '@/router';
import { toGetApp } from '@/untils/knowledege';
import { ref } from 'vue';
import { onMounted } from 'vue';
import { reactive } from 'vue';
import {getFileList,fileImport,fileDelete, remainStorage} from './index'
import dayjs from 'dayjs';
import { message } from 'ant-design-vue/lib/components';
import { watch } from 'vue';
import store from '@/store';
 const  cardList=ref([])
 const cardItem=ref('')
 const routeValue=ref('')
 const reloading=ref(true)
 const documentList=ref([])
 const scrollView=ref('')
 const eleName =ref('')
 const containerItem= ref('')
 watch(()=>router.currentRoute.value,(val)=>{
    if(router.currentRoute.value.path.indexOf('knowledgeManageDetail')>-1){
        routeValue.value=router.currentRoute.value
        toGetAppName()
    }
  
   
 })
 onMounted(async()=>{
    routeValue.value=router.currentRoute.value
    var height = document.getElementById('container').offsetHeight
    scrollView.value = { height: (height - 30) + 'px', overflow: 'auto' }
    if(store.getters.knowledgeAPPList.length==0)
    cardList.value= await toGetApp()
    else  cardList.value= store.getters.knowledgeAPPList
    if(cardList.value.length==0){
        router.replace({ name: 'mainPage' })
    }else{
        
        toGetAppName()
    var typeList=['pdf','ppt','pptx','docx','doc','txt','md','html','xls','xlsx']
    var l=0
    }
 
    // for(var i =0;i<100;i++){
    //     if(l>typeList.length-1){
    //         l=0
    //     }
    //     documentList.value.push({
    //         id:i,
    //         name:'（环评）拟在建项目-滦州市城区供热管网综合改造项目（环评）拟在建项目-滦州市城区供热管网综合改造项目（环评）拟在建项目-滦州市城区供热管网综合改造项目（环评）拟在建项目-滦州市城区供热管网综合改造项目（环评）拟在建项目-滦州市城区供热管网综合改造项目（环评）拟在建项目-滦州市城区供热管网综合改造项目',
    //         time:'2024-11-09 19:40:57',
    //         size:'6.68 KB',
    //         type:typeList[l]
    //     })
    //     l++
    // }
 })
 const remainStorageValue=ref('')
 const togetRemainStorage=()=>{
    dotLoading.value=true
    remainStorage({companyId:store.getters.company.companyId}).then((res)=>{
  
        var storage=0
        for(var i in res.data){
            storage=storage+res.data[i].totalSize
        }
        remainStorageValue.value=getReadableRemaining(storage)
          dotLoading.value=false
    })
 }
 const getReadableRemaining=(usedBytes) =>{
    const totalBytes = 5 * 1024 * 1024 * 1024; // 5GB 转 Bytes
    const remainingBytes = totalBytes - usedBytes;

    if (remainingBytes < 0) {
        return "已超限"; // 处理异常情况（已用容量超过总容量）
    }

    // 计算 GB、MB、KB
    const gb = remainingBytes / (1024 ** 3);
    const mb = remainingBytes / (1024 ** 2);
    const kb = remainingBytes / 1024;
    console.log(gb,mb,kb,'gbmbkb')
    // 动态选择最合适的单位
  if (gb >= 1) {
        return gb % 1 === 0 ? `${gb} GB` : `${gb.toFixed(3)} GB`;
    } else if (mb >= 1) {
        return mb % 1 === 0 ? `${mb} MB` : `${mb.toFixed(2)} MB`;
    } else if (kb >= 1) {
        return kb % 1 === 0 ? `${kb} KB` : `${kb.toFixed(2)} KB`;
    } else {
        return `${remainingBytes} Bytes`;
    }
}
  const toGetAppName=()=>{

   
    if(cardList.value.length>0&&routeValue.value.query.knowId&&routeValue.value.query.containerId){
        
        var result =  cardList.value.find(item=>item.id==Number(routeValue.value.query.knowId))
        console.log(result,'result')
        if(result) {
            result.containers= result.containers instanceof Array? result.containers: JSON.parse(result.containers)
            cardItem.value=result
            result =result.containers.find(item=>item.id==Number(routeValue.value.query.containerId))
            if(result){
               
                containerItem.value =result
            
                 toGetFileList()
            }
            else {
                returnMain()
            }
            
        }
        else returnMain()
    }
    else {
        returnMain()
    }
    reloading.value=false
 }
 const pagination=reactive({
    current:1,
    pageSize:10,
    total: 0,
      showTotal: function (total) {
        return "共：" + total + " 条";
      },
 })
 const toGetFileList=()=>{
    togetRemainStorage()
    reloading.value=true
      getFileList({get:{id:cardItem.value.id,pageNo:pagination.current,pageSize:pagination.pageSize,eleName:eleName.value,containerId:containerItem.value.id}}).then((res)=>{
        reloading.value=false
        pagination.total=res.data.total
        documentList.value=res.data.data
        reloading.value=false
        
        console.log(res,'pageNo ')
      })
 }
 
 const returnMain=()=>{
    router.replace({ name: 'mainPage' })
 }

 const  columns = ref([
    {
          title: " 序号 ",
          // render: (text, record, index) => `${index + 1}`,  //每一页都从1开始
          customRender: (column) =>
            `${(pagination.current - 1) * pagination.pageSize + column.index + 1
            }`,
          width: "5%",
          align: 'center'
          //当前页数减1乘以每一页页数再加当前页序号+1
    },
    {
          title: " 名称 ",
          customCell:()=>{
              return {
                class: {
      'single-line-ellipsis': true,
     
    },
              }
          },
            width:"70%",
          dataIndex: 'eleName',
          //当前页数减1乘以每一页页数再加当前页序号+1
    },
    {
          title: " 创建时间 ",

          width: "15%",
          dataIndex: 'createTime',
          //当前页数减1乘以每一页页数再加当前页序号+1
    },
    {
          title: " 文件大小 ",

          width: "10%",
          dataIndex: 'eleSizeDisplay',
          //当前页数减1乘以每一页页数再加当前页序号+1
    },
    {
          title: " 状态 ",

          width: "10%",
          dataIndex: 'processStatus',
          //当前页数减1乘以每一页页数再加当前页序号+1
    },
    {
          title: " 操作 ",

          width: "5%",
          dataIndex: 'action',
          //当前页数减1乘以每一页页数再加当前页序号+1
    },
 ])
//  const acceptedFormats= ref('.pdf,.ppt,.docx,.doc,.txt,.md,.html,.xls,.xlsx')
const acceptedFormats=ref(
    ['application/pdf',               // .pdf
        'application/vnd.ms-powerpoint',  // .ppt
        'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
        'application/msword',             // .doc
        'text/plain',                     // .txt
        'text/markdown',                  // .md
        'text/html',                      // .html
        'application/vnd.ms-excel',       // .xls
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        ].toString())
        const fileList =ref([])
 const beforeUpload=(file)=>{
   
     return false
  
 }
 const handleChange=()=>{

  fileList.value.map((item=>{
    console.log(item.type,'item.type')
    if(item.type!=''&&acceptedFormats.value.includes(item.type))  item.status='done'
    else item.status='error'
     return  item 
  }))

 }
 const visible=ref(false)
 const getSvgName=(val)=>{
  
     if(val.indexOf('pdf')>-1) return 'pdf'
     else if(val.indexOf('doc')>-1) return 'word'
     else if(val.indexOf('txt')>-1) return 'txt'
     else if(val.indexOf('ppt')>-1) return 'ppt'
     else return '未知'
 }
 const getTime=(val)=>{
    return dayjs(val).format("YYYY-MM-DD HH:mm:ss")
 }
 const handleTableChange=(page) =>{
      pagination.current =
        page.pageSize != pagination.pageSize ? 1 : page.current;
      pagination.pageSize = page.pageSize;
      document.querySelector('.scrollView').scrollTop = 0
      toGetFileList()
    }
const confirmLoading=ref(false)
//知识导入
const handleOk= ()=>{
    console.log(fileList.value)
   var flag= fileList.value.some(item=>item.status=='error')
   if(flag==true){
     message.warning('部分文件格式无法上传，请检查！')
   }
    else{
    
        confirmLoading.value= true
        var formData = new FormData();
        for (let i = 0; i < fileList.value.length; i++) {
            console.log(fileList.value[i].originFileObj
            )
        formData.append('files', fileList.value[i].originFileObj
    ); // 'files[]' 是服务器端接收的字段名
  }
    console.log(formData)
       
        fileImport({get:{id:cardItem.value.id,containerId:containerItem.value.id},post:formData}).then(()=>{
             message.success('文件已上传成功')
             confirmLoading.value= false
             visible.value=false
             initData()
        }).catch(()=>{
            message.error('文件上传失败')
            confirmLoading.value= false
        })
   }

//    else{
//      const successResults = [];
//     const failResults = [];
//         confirmLoading.value= true
//         var formData = new FormData();
//         for (let i = 0; i < fileList.value.length; i++) {

//          try {
//       const result = await uploadFile(fileList.value[i].originFileObj);
//       successResults.push({ 
//         fileName: fileList.value[i].originFileObj.name, 
     
//       })
//     } catch (error) {
//        console.log(error,'successResultserror')
//       failResults.push({ 
//         fileName: fileList.value[i].originFileObj.name, 
    
//       })
//     }
// console.log(successResults,failResults,'successResults,failResults')
 
  
//   // 显示上传结果
//   if (failResults.length === 0) {
//     message.success(`全部成功！共上传 ${successResults.length} 个文件`) 
//     confirmLoading.value= false
//     visible.value=false
//     initData()
//   } else if (successResults.length === 0) {
//      message.error(`全部失败！共 ${failResults.length} 个文件上传失败`)
//        confirmLoading.value= false
//     } else {
//      message.error(`部分成功！成功: ${successResults.length} 个，失败: ${failResults.length} 个`)
//        confirmLoading.value= false
//     }
          
        
    
//         // formData.append('files', fileList.value[i].originFileObj ); // 'files[]' 是服务器端接收的字段名
//   }

    
       
//         // fileImport({get:{id:cardItem.value.id,containerId:containerItem.value.id},post:formData}).then(()=>{
//         //      message.success('文件已上传成功')
//         //      confirmLoading.value= false
//         //      visible.value=false
//         //      initData()
//         // }).catch(()=>{
//         //     message.error('文件上传失败')
//         //     confirmLoading.value= false
//         // })
//    }
    //  if(confirmLoading.value==false){
    //      confirmLoading.value= true
        
        
    //  }   
}

// // 文件上传函数
// const   uploadFile = async (file) => {
//   const formData = new FormData();
//   formData.append('files', file);
  

//     const response = await  fileImport({get:{id:cardItem.value.id,containerId:containerItem.value.id},post:formData})
//     console.log(response,'response',file.name)
//     if (!response.data.statusCodeValue===200) {
//        throw new Error('上传失败:'+file.name);
  
//     }
//     return ;


  
// }
// const handleCancel=()=>{
//     if(confirmLoading.value==true) return 
//     else  visible.value=false
// }
 const initData=()=>{
    
    pagination.current=1
          
          toGetFileList()
 }
const toImport=()=>{
     visible.value=true
     fileList.value=[]
}

const toDeleteConfirm=(val)=>{
    fileDelete({get:{id:val,containerId:containerItem.value.id}}).then((res)=>{
        message.success('删除成功')
        initData()
    })
}
const toSearch=()=>{
    initData()
}
const toClickContainerId=(item)=>{
  
    router.push({path:'/knowledgeManageDetail',query:{knowId:cardItem.value.id,containerId:item.id}})
}
const dotLoading=ref(true)

</script>
<style lang="css">
.single-line-ellipsis {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    word-break: keep-all;
    max-width: 100%;
}
.ant-upload.ant-upload-drag:not(.ant-upload-disabled):hover{
    border-color:#00b2b9 !important
}

</style>
<style lang="less">
.spinClass{
    height: 100%;
    .ant-spin-container{
        height: 100%;
    }
}
.dialogKnowledgeClass {
    .ant-btn-primary{
        background: rgb(0, 178, 185);
        border-color: rgb(0, 178, 185);
    }
}
</style>
<style scoped lang="less">
    .dots-loader {
  font-size: 24px;
  display: inline-block;
}

.dots-loader::after {
  content: "...";
  animation: dot-flash 0.5s infinite;
}

@keyframes dot-flash {
  0%, 100% { opacity: 0.3; }
  50% { opacity: 1; }
}
    .volumnText{
       font-weight: normal;
    color: #979799;
    font-size: 15px;
    }
.cardItem{
    padding: 10px 0px;
    cursor: pointer;
}
.cardItem :hover{
    color: #009da6;
}
.cardItem.selected{
    background-color: #e6f7ff;
    color: #009da6;
}
.appName{
    color: #009688;
}
.appName::after{
    position: relative;
    top: 12px;
    display: block;
    width:100%;
    height: 1px;
    background: #f0f0f0;
    content: "";
}

.ant-upload.ant-upload-drag p.ant-upload-drag-icon .anticon{
    color:#00b2b9 !important
}
.table_name:hover{
 color:#00b2b9
}
.table_name{
color: black;
}

.scrollView {
  margin: 10px 0px;
}
#container{
    width: 100%;
    padding: 20px 40px;
}
    .head {
        font-size: 16px;
        font-weight: 700;
        color: #333;
        display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    .search {
        display: flex;
    align-items: center;
    margin-bottom: 10px;
         .title{
            font-size: 18px;
    margin-right: 10px;
    margin-bottom: 0;
         }
    }
    }
</style>